import { render, staticRenderFns } from "./ReactivePopover.vue?vue&type=template&id=042ef520"
import script from "./ReactivePopover.vue?vue&type=script&lang=js"
export * from "./ReactivePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports